export const SETTINGS_ROUTES = {
  PROFILE: '/perfil',
  APPEARANCE: '/aparencia',
  PERMISSIONS: '/permissoes',
} as const;
